/**
 * HydroJug Landing Page Template JavaScript
 * Handles countdown timer, FAQ accordion, and Klaviyo form styling
 */

(function() {
  'use strict';

  let faqResizeListenerBound = false;

  // ========================================
  // Countdown Timer
  // ========================================
  function initCountdown() {
    const countdownElement = document.querySelector('[data-countdown-target]');
    if (!countdownElement) return;

    const targetDate = new Date(countdownElement.dataset.countdownTarget);
    const daysEl = countdownElement.querySelector('[data-countdown-days]');
    const hoursEl = countdownElement.querySelector('[data-countdown-hours]');
    const minutesEl = countdownElement.querySelector('[data-countdown-minutes]');
    const secondsEl = countdownElement.querySelector('[data-countdown-seconds]');

    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

    function updateCountdown() {
      const now = new Date().getTime();
      const distance = targetDate.getTime() - now;

      if (distance < 0) {
        // Countdown finished
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        
        // Swap hero buttons: hide pre-launch, show post-launch
        const heroContent = countdownElement.closest('.hjlp-hero__content');
        if (heroContent) {
          const preBtns = heroContent.querySelector('[data-hero-buttons="pre"]');
          const postBtns = heroContent.querySelector('[data-hero-buttons="post"]');
          if (preBtns) preBtns.style.display = 'none';
          if (postBtns) postBtns.style.display = '';
        }
        
        return;
      }

      // Calculate time units
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Update DOM with padded values
      daysEl.textContent = String(days).padStart(2, '0');
      hoursEl.textContent = String(hours).padStart(2, '0');
      minutesEl.textContent = String(minutes).padStart(2, '0');
      secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    // Initial update
    updateCountdown();

    // Update every second
    const intervalId = setInterval(updateCountdown, 1000);

    // Cleanup on page unload
    window.addEventListener('beforeunload', function() {
      clearInterval(intervalId);
    });
  }

  // ========================================
  // FAQ Accordion
  // ========================================
  function initFAQ() {
    const faqSections = document.querySelectorAll('.hjlp-faq');
    if (!faqSections.length) return;

    function setItemOpenState(item, shouldOpen) {
      const button = item.querySelector('.hjlp-faq__question');
      const answer = item.querySelector('.hjlp-faq__answer');
      if (!button || !answer) return;

      if (shouldOpen) {
        item.classList.add('hjlp-faq__item--open');
        button.setAttribute('aria-expanded', 'true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      } else {
        item.classList.remove('hjlp-faq__item--open');
        button.setAttribute('aria-expanded', 'false');
        answer.style.maxHeight = '0';
      }
    }

    faqSections.forEach(function(section) {
      const faqItems = section.querySelectorAll('.hjlp-faq__item');
      if (!faqItems.length) return;

      faqItems.forEach(function(item) {
        const button = item.querySelector('.hjlp-faq__question');
        const answer = item.querySelector('.hjlp-faq__answer');

        if (!button || !answer) return;

        // Prevent double-binding when initFAQ() runs multiple times.
        if (button.getAttribute('data-hjlp-faq-bound') === 'true') {
          // Still ensure heights are correct (e.g. after theme editor re-render).
          setItemOpenState(item, item.classList.contains('hjlp-faq__item--open'));
          return;
        }
        button.setAttribute('data-hjlp-faq-bound', 'true');

        // Ensure a consistent initial state (inline max-height beats CSS).
        setItemOpenState(item, item.classList.contains('hjlp-faq__item--open'));

        button.addEventListener('click', function() {
          const isOpen = item.classList.contains('hjlp-faq__item--open');
          setItemOpenState(item, !isOpen);
        });

        // Keyboard support (Enter and Space)
        button.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            button.click();
          }
        });
      });
    });

    // Recalculate max-height on window resize for open items (bind once).
    if (!faqResizeListenerBound) {
      faqResizeListenerBound = true;
      let resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          document.querySelectorAll('.hjlp-faq__item--open .hjlp-faq__answer').forEach(function(answer) {
            answer.style.maxHeight = answer.scrollHeight + 'px';
          });
        }, 250);
      });
    }
  }

  // ========================================
  // Klaviyo custom trigger (openForm)
  // ========================================
  function openKlaviyoForm(formId) {
    if (!formId) return;
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
    // Retry once after a short delay in case Klaviyo script loaded after our init
    setTimeout(function() {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    }, 400);
  }

  function initKlaviyoTrigger() {
    // Ensure Klaviyo queue exists (script may load later)
    window._klOnsite = window._klOnsite || [];

    // Button triggers (e.g. submit button with class klaviyo_form_trigger)
    var triggers = document.querySelectorAll('.klaviyo_form_trigger');
    triggers.forEach(function(btn) {
      if (btn.getAttribute('data-klaviyo-bound')) return;
      btn.setAttribute('data-klaviyo-bound', 'true');
      btn.addEventListener('click', function(e) {
        if (btn.type === 'submit') {
          e.preventDefault();
          var form = btn.closest('form');
          if (form && !form.checkValidity()) {
            form.reportValidity();
            return;
          }
        }
        var formId = btn.getAttribute('data-form-id');
        openKlaviyoForm(formId);
      });
    });

    // Email form submit: prevent default, open Klaviyo form
    var emailForms = document.querySelectorAll('.hjlp-notify__email-form');
    emailForms.forEach(function(form) {
      if (form.getAttribute('data-klaviyo-bound')) return;
      form.setAttribute('data-klaviyo-bound', 'true');
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var btn = form.querySelector('.klaviyo_form_trigger');
        var formId = btn ? btn.getAttribute('data-form-id') : null;
        openKlaviyoForm(formId);
      });
    });
  }

  // ========================================
  // Klaviyo Form Styling Injector
  // ========================================
  function styleKlaviyoForms() {
    // CSS to inject into Klaviyo forms for cohesive styling with SMS card
    const klaviyoCSS = `
      /* Override Klaviyo form container */
      .klaviyo-form {
        width: 100% !important;
        max-width: 100% !important;
        background: transparent !important;
        padding: 0 !important;
        margin: 0 !important;
      }

      #rich-text-01KG83V7T7WH4FD7YVYCDH16X5 {
        display: none !important;
      }

      /* Hide internal headings - we use the card title */
      .klaviyo-form h1,
      .klaviyo-form h2,
      .klaviyo-form h3,
      .klaviyo-form h4 {
        display: none !important;
      }

      /* Normalize body copy */
      .klaviyo-form p {
        color: #6b6b6b !important;
        font-size: 14px !important;
        line-height: 1.6 !important;
        margin: 0 0 12px 0 !important;
        text-align: left !important;
      }

      /* Hide decorative icons */
      .klaviyo-form svg {
        display: none !important;
      }
      
      /* Hide Klaviyo default close button and extra elements */
      .klaviyo-form .klaviyo-close-form,
      .klaviyo-form .close-button,
      .klaviyo-form .klaviyo-header {
        display: none !important;
      }
      
      /* Form content wrapper */
      .klaviyo-form .form-content,
      .klaviyo-form form {
        background: transparent !important;
        padding: 0 !important;
        margin: 0 !important;
        box-shadow: none !important;
      }
      
      /* Input fields - match SMS card input styling */
      .klaviyo-form input[type="email"],
      .klaviyo-form input[type="text"],
      .klaviyo-form input {
        width: 100% !important;
        padding: 14px 16px !important;
        border: 1px solid #ddd !important;
        border-radius: 6px !important;
        font-size: 16px !important;
        font-family: inherit !important;
        background: white !important;
        color: #333 !important;
        margin-bottom: 12px !important;
        box-sizing: border-box !important;
        transition: border-color 0.2s ease, box-shadow 0.2s ease !important;
      }
      
      .klaviyo-form input[type="email"]:focus,
      .klaviyo-form input[type="text"]:focus,
      .klaviyo-form input:focus {
        outline: none !important;
        border-color: #0066cc !important;
        box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.1) !important;
      }
      
      /* Submit button - match SMS card blue button */
      .klaviyo-form button[type="submit"],
      .klaviyo-form .klaviyo-submit-button,
      .klaviyo-form button {
        width: 100% !important;
        padding: 14px 20px !important;
        background: #0066cc !important;
        color: white !important;
        border: none !important;
        border-radius: 6px !important;
        font-size: 16px !important;
        font-weight: 600 !important;
        font-family: inherit !important;
        cursor: pointer !important;
        transition: background 0.2s ease, transform 0.1s ease !important;
        margin-top: 4px !important;
        display: block !important;
        text-transform: none !important;
      }
      
      .klaviyo-form button[type="submit"]:hover,
      .klaviyo-form .klaviyo-submit-button:hover,
      .klaviyo-form button:hover {
        background: #0052a3 !important;
        transform: translateY(-1px) !important;
      }
      
      .klaviyo-form button[type="submit"]:active,
      .klaviyo-form .klaviyo-submit-button:active,
      .klaviyo-form button:active {
        transform: translateY(0) !important;
      }
      
      /* Labels */
      .klaviyo-form label,
      .klaviyo-form .klaviyo-label {
        font-size: 14px !important;
        font-weight: 500 !important;
        color: #333 !important;
        margin-bottom: 6px !important;
        display: block !important;
      }
      
      /* Remove default form padding/margins */
      .klaviyo-form .klaviyo-form-row,
      .klaviyo-form .form-row,
      .klaviyo-form .klaviyo-field {
        margin: 0 !important;
        padding: 0 !important;
        margin-bottom: 8px !important;
      }
      
      /* Hide any teaser or extra content */
      .klaviyo-form .teaser,
      .klaviyo-form .klaviyo-teaser {
        display: none !important;
      }
    `;

    const klaviyoSelector = '[class^="klaviyo-form-"], [class*=" klaviyo-form-"], .klaviyo-form';

    // Function to inject CSS into a shadow root
    function injectStylesIntoShadow(shadowRoot) {
      if (!shadowRoot) return;
      
      // Check if we've already injected styles
      if (shadowRoot.querySelector('#hjlp-klaviyo-styles')) return;
      
      const style = document.createElement('style');
      style.id = 'hjlp-klaviyo-styles';
      style.textContent = klaviyoCSS;
      shadowRoot.appendChild(style);
    }

    function injectStylesIntoElement(element) {
      if (!element || !element.querySelector) return;
      if (element.querySelector('#hjlp-klaviyo-styles')) return;

      const style = document.createElement('style');
      style.id = 'hjlp-klaviyo-styles';
      style.textContent = klaviyoCSS;
      element.appendChild(style);
    }

    function applyStylesToNode(node) {
      if (!node || node.nodeType !== 1) return;

      if (node.matches && node.matches(klaviyoSelector)) {
        if (node.shadowRoot) {
          injectStylesIntoShadow(node.shadowRoot);
        } else {
          injectStylesIntoElement(node);
        }
      }

      const nested = node.querySelectorAll ? node.querySelectorAll(klaviyoSelector) : [];
      nested.forEach(function(form) {
        if (form.shadowRoot) {
          injectStylesIntoShadow(form.shadowRoot);
        } else {
          injectStylesIntoElement(form);
        }
      });
    }

    // Observe for Klaviyo forms being added to the DOM
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          applyStylesToNode(node);
        });
      });
    });

    // Start observing
    observer.observe(document.body, { childList: true, subtree: true });

    // Also try to style any existing forms immediately
    document.querySelectorAll(klaviyoSelector).forEach(function(form) {
      applyStylesToNode(form);
    });

    // Retry after Klaviyo script likely loads
    setTimeout(function() {
      document.querySelectorAll(klaviyoSelector).forEach(function(form) {
        applyStylesToNode(form);
      });
    }, 1000);

    setTimeout(function() {
      document.querySelectorAll(klaviyoSelector).forEach(function(form) {
        applyStylesToNode(form);
      });
    }, 3000);
  }

  // ========================================
  // Initialize on DOM Ready
  // ========================================
  function init() {
    initCountdown();
    initFAQ();
    initKlaviyoTrigger();
    styleKlaviyoForms();
  }

  // Check if DOM is already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor support
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.classList.contains('section-hj-landing-hero')) {
        initCountdown();
      }
      if (event.target.classList.contains('section-hj-landing-faq')) {
        initFAQ();
      }
      if (event.target.classList.contains('section-hj-landing-notify')) {
        initKlaviyoTrigger();
        styleKlaviyoForms();
      }
    });
  }

})();
